import { USERS_PATH } from '../constants/apiConstants';
import { getGeotraxBaseUrl } from '../util/apiUtil';
import { getIdFromUrl } from '../util/appUtil';
import { getRequest, putRequest } from './requestService';
import { GeotraxUserPreferencesDto } from '../types';

const defaultUserPreferences: GeotraxUserPreferencesDto = {
  mapFilters: {},
};

export async function getUserPreferences(userUrl: string) {
  const id = getIdFromUrl(userUrl);
  const url = `${getGeotraxBaseUrl()}${USERS_PATH}/preferences/${id}`;

  try {
    const response = await getRequest(url);
    const fetchedUserPreferences = response?.data;
    return fetchedUserPreferences
      ? (fetchedUserPreferences as GeotraxUserPreferencesDto)
      : defaultUserPreferences;
  } catch (e: any) {
    // Swallow error and return undefined
    return undefined;
  }
}

export async function updateUserPreferences(
  userUrl: string,
  userPreferences: GeotraxUserPreferencesDto,
) {
  const id = getIdFromUrl(userUrl);
  const url = `${getGeotraxBaseUrl()}${USERS_PATH}/preferences/${id}`;

  try {
    const response = await putRequest(url, { preferences: JSON.stringify(userPreferences) });
    const updatedUserPreferences = response.data;
    return updatedUserPreferences
      ? (updatedUserPreferences as GeotraxUserPreferencesDto)
      : defaultUserPreferences;
  } catch (e: any) {
    // Swallow error and return undefined
    return undefined;
  }
}
